<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/U4hiPV/tc-custom/9781635765854.jpg?1737057940384" alt="This image is the cover for the book Bourbon King"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Bourbon King
      </h1>
      <p class="bookDescription body article font2">
        <p><b>The rise and fall of the man who cracked Prohibition to become one of the world’s richest criminal masterminds—and helped inspire <i>The Great Gatsby</i>.</b><br/><br/> Love, murder, political intrigue, mountains of cash, and rivers of bourbon…The tale of George Remus is a grand spectacle and a lens into the dark heart of Prohibition. Yes, Congress gave teeth to Prohibition in October, 1919, but the law didn’t stop George Remus from amassing a fortune that would be worth billions of dollars today. As one Jazz Age journalist put it, “Remus was to bootlegging what Rockefeller was to oil.”<br/><br/> Author Bob Batchelor breathes life into the largest bootlegging operation in America—greater than that of Al Capone—and a man considered the best criminal defense lawyer of his era. Remus bought an empire of distilleries on Kentucky’s “Bourbon Trail” and used his other profession, as a pharmacist, to profit off legal loopholes. He spent millions bribing officials in the Harding Administration, and he created a roaring lifestyle that epitomized the Jazz Age over which he ruled.<br/><br/> That is, before he came crashing down in one of the most sensational murder cases in American history: a cheating wife, the G-man who seduced her and put Remus in jail, and the plunder of a Bourbon Empire. Remus murdered his wife in cold-blood and then shocked a nation winning his freedom based on a condition he invented—temporary maniacal insanity.<br/><br/><b>“The fantastic story of George Remus makes the rest of the “Roaring Twenties” look like the “Boring Twenties” in comparison.” ―David Pietrusza, author of <i>1920: The Year of the Six Presidents</i></b></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Bob Batchelor
      </h2>
      
      <p class="authorDescription body article">Bob Batchelor is a critically acclaimed, bestsellingcultural historian and biographer. He has published widely on Americanhistory and literature, including books on Stan Lee, Bob Dylan, The Great Gatsby, Mad Men, and John Updike. Bob earned his doctorate in English Literature fromthe University of South Florida. He teaches in the Media, Journalism& Film department at Miami University (Oxford, Ohio) and lives withhis wife Suzette and teenage daughters in Cincinnati.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Diversion Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?06232ad7